// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Mrg0","approved":"Status_approved__OcqQY","rejected":"Status_rejected__1M9L2","expired":"Status_expired__Fp7I5","label":"Status_label__1DUb7"};